import { USER_INFO_START, RESET_INFO_USER } from "../actionType";

export const userInfoAction = () => ({
  type: USER_INFO_START,
});

export const userResetInfo = () => ({
  type: RESET_INFO_USER,
});
